module.exports = __webpack_public_path__ + "static/media/AAVE-BNB.8603dd0e.svg";